<script setup lang="ts">
import { useDateFns } from '@apparatix/composables';
import Typography from '@apparatix/library/core/typography/Typography';

type Props = {
  date: number,
};

const props = defineProps<Props>();

const { fromUnixTimestamp, formatDate } = useDateFns();
</script>
<template>
  <Typography variant="small-body" muted>
    {{ formatDate(fromUnixTimestamp(props.date), 'iii, LLL d, h:mm aaa', '') }}
  </Typography>
</template>
